export const AnimateNumbers = () => {
	const animateNumbers = document.querySelectorAll('.animate-number-js');
	let animationTriggered = false;

	const animateNumber = (index, value) => {
		setTimeout(() => {
			animateNumbers[index].textContent = value;
		}, 100 + 20 * value);
	};

	if (animateNumbers.length) {
		window.addEventListener('scroll', () => {
			if (animationTriggered) return;

			const sectionOffset = animateNumbers[0].offsetTop;

			if (window.scrollY + window.innerHeight > sectionOffset + 100) {
				for (let y = 0; y < animateNumbers.length; y++) {
					const statistic = parseInt(
						animateNumbers[y].dataset.statistic,
						10
					);

					for (let i = 0; i < statistic + 1; i++) {
						animateNumber(y, i);
					}
				}

				animateNumbers.forEach((el) =>
					el.classList.remove('animate-number-js')
				);

				animationTriggered = true;
			}
		});
	}
};
